import HowOthersAnswered from './HowOthersAnsweredWrapper.react';

export default HowOthersAnswered;
